module.exports = __webpack_public_path__ + "assets/img/vtuber-ads8.d0318f12.png";